module.exports = __webpack_public_path__ + "3c4676d1a8278be1ba1ed62d7126b6f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/X@2x.png
// module id = 839
// module chunks = 0